module.exports = __webpack_public_path__ + "static/media/picked.36b94156.mp3";